import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
//import { Attachment } from '../../../shared-components/models/attachment.model';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MassEmailAttachment } from '../mass-email.model';

@Component({
    selector: 'app-mass-email-attachment',
    templateUrl: './mass-email-attachment.component.html'
})
export class MassEmailAttachmentComponent implements OnInit {
    emailAttachment: MassEmailAttachment;
    errors: ErrorList[] = [];
    @ViewChild('fileInput', { read: ElementRef, static: true }) fileInputRef: ElementRef;
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogBox: MatDialogRef<MassEmailAttachmentComponent>,
    ) {
        this.emailAttachment = new MassEmailAttachment();
    }

    ngOnInit() {

    }

    validate() {
        this.errors = [];
        if (this.emailAttachment.FileExtension.toLowerCase() != 'pdf' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'jpg' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'png' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'txt' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'doc' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'docx' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'xls' &&
            this.emailAttachment.FileExtension.toLowerCase() != 'xlsx') {
            this.errors.push({
                fieldRef: null,
                fieldName: 'File',
                errorMsg: 'Only .txt, .doc(x), .xls(x), .pdf, .jpg, and .png files can be uploaded.'
            });
        }

        if (this.emailAttachment.OriginalFileName == '' || this.emailAttachment.OriginalFileName == undefined) {
            this.errors.push({
                fieldRef: this.fileInputRef,
                fieldName: 'File',
                errorMsg: 'File required.'
            });
        }
    }

    OKClick() {
        this.validate();
        if (this.errors.length == 0) {
            this.emailAttachment.FileName = this.emailAttachment.OriginalFileName
            this.dialogBox.close(this.emailAttachment);
        }
    }

    closeClick() {
        this.dialogBox.close();
    }

}
